var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35, 25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-10,0 10,0 8,6 -8,6",
    fill: "#fe019a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-21,10 -1,10 -3,16 -19,16",
    fill: "#fe019a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1,10 21,10 19,16 3,16",
    fill: "#fe019a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-32,20 -12,20 -14,26 -30,26",
    fill: "#fe019a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-10,20 10,20 8,26 -8,26",
    fill: "#fe019a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,20 32,20 30,26 14,26",
    fill: "#fe019a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cfae7ab6633219e29169a13a7d299ffc.svg";
export { ForwardRef as ReactComponent };